import { Component, Injector, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { Owner } from '@app/forms/subscription/definition/interface/Pledge';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { patrimonyValueOptions } from '../../services/ref';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'heritage-form',
    templateUrl: './heritage-form.component.html',
    styleUrls: ['./heritage-form.component.scss'],
    standalone: false
})
export class HeritageFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  owner: Owner;
  subTitle = '';
  options2 = [
    { value: '1', label: '< 100 000€', suffix: { title: 'A' } },
    { value: '2', label: '100 000 - 300 000€', suffix: { title: 'B' } },
    { value: '3', label: '300 000 - 500 000€', suffix: { title: 'C' } },
    {
      value: '4',
      label: '500 000 - 1 000 000€',
      suffix: { title: 'D' },
    },
    {
      value: '5',
      label: '1 000 000 - 2 000 000€',
      suffix: { title: 'E' },
    },
    {
      value: '6',
      label: '2 000 000 - 5 000 000€',
      suffix: { title: 'F' },
    },
    {
      value: '7',
      label: '5 000 000 - 10 000 000€',
      suffix: { title: 'G' },
    },
    { value: '8', label: '> 10 000 000€', suffix: { title: 'H' } },
  ];
  options: FormControlOption[] = patrimonyValueOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
    // new add
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const owner = pledge?.owners?.find(o => o.isMain);
    this.owner = owner || pledge?.owners?.[0];
    this.subTitle = pledge?.parameters?.patrimonyValueEstimation
      ? `Selon albR, nous estimons la valeur de votre patrimoine à
    ${pledge?.parameters?.patrimonyValueEstimation} €`
      : '';

    this.subscriptionFacade.initForm(this);

    this.owners
      .get(`${0}`)
      .get('riskProfil')
      .get('patrimonyValue')
      .valueChanges.pipe(untilDestroyed(this))
      .subscribe(data => {
        if (data == 'GREATER_THAN_10M') {
          this.owners
            .get(`${0}`)
            .get('montant')
            .setValidators([
              Validators.required,
              Validators.min(1000000),
              Validators.pattern(/^[0-9]*$/),
            ]);

          this.owners.get(`${0}`).get('montant').updateValueAndValidity();
        } else {
          this.owners.get(`${0}`).get('montant').setValidators([]);

          this.owners.get(`${0}`).get('montant').updateValueAndValidity();
        }
      });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
